import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

export const StyledItem = styled('button')(({ disabled }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.5 : undefined,
  pointerEvents: disabled ? 'none' : undefined,
  border: `2px solid ${COLORS.white}`,
  '&:hover': {
    borderColor: COLORS.primary,
    // backgroundColor: COLORS.white,
    background: 'radial-gradient(972.57% 7936.73% at 50.09% 50%, rgba(4, 135, 230, 0) 0%, #0487E6 100%)',
  },
  borderRadius: '16px',
  padding: '18px',
  gap: '12px',
  boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.05)',
  backgroundColor: COLORS.white,
  width: '100%',
  height: '100%',
}));

export const StyledImageContainer = styled('div')({
  background: COLORS.blue50,
  borderRadius: '12px',
  padding: '11px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
